"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1497))
 * @trackcomponent
 * @lastsynced 2025-03-05T20:51:05.046Z
 */
export const CartEmpty = createSVGIcon(
  <>
    <path
      d="M20.7406 14.7143H7.74288L6.0286 5.28571H22.1429C22.2684 5.28571 22.3923 5.31326 22.506 5.36642C22.6196 5.41958 22.7202 5.49705 22.8007 5.59335C22.8811 5.68965 22.9395 5.80244 22.9715 5.92376C23.0036 6.04507 23.0086 6.17194 22.9863 6.29542L21.584 14.0097C21.5483 14.2074 21.4442 14.3862 21.2901 14.515C21.1359 14.6437 20.9415 14.7143 20.7406 14.7143Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.02881 5.28571L5.30881 1.68571C5.26929 1.49211 5.16409 1.3181 5.01102 1.19315C4.85795 1.06819 4.66641 0.99996 4.46881 1H1.74309"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.74288 14.7143L8.46289 18.3143C8.5024 18.5079 8.6076 18.6819 8.76067 18.8069C8.91374 18.9318 9.10529 19 9.30288 19H18.8857"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8838 22.4286C18.8838 22.5411 18.8616 22.6526 18.8185 22.7566C18.7755 22.8606 18.7123 22.9551 18.6327 23.0346C18.5531 23.1142 18.4587 23.1774 18.3547 23.2205C18.2507 23.2635 18.1392 23.2857 18.0266 23.2857C17.9141 23.2857 17.8026 23.2635 17.6986 23.2205C17.5946 23.1774 17.5001 23.1142 17.4206 23.0346C17.341 22.9551 17.2778 22.8606 17.2347 22.7566C17.1917 22.6526 17.1695 22.5411 17.1695 22.4286C17.1695 22.316 17.1917 22.2045 17.2347 22.1005C17.2778 21.9965 17.341 21.9021 17.4206 21.8225C17.5001 21.7429 17.5946 21.6797 17.6986 21.6367C17.8026 21.5936 17.9141 21.5714 18.0266 21.5714C18.1392 21.5714 18.2507 21.5936 18.3547 21.6367C18.4587 21.6797 18.5531 21.7429 18.6327 21.8225C18.7123 21.9021 18.7755 21.9965 18.8185 22.1005C18.8616 22.2045 18.8838 22.316 18.8838 22.4286Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1699 22.4286C11.1699 22.6559 11.0796 22.8739 10.9189 23.0346C10.7581 23.1954 10.5401 23.2857 10.3128 23.2857C10.0855 23.2857 9.86743 23.1954 9.70669 23.0346C9.54594 22.8739 9.45564 22.6559 9.45564 22.4286C9.45564 22.2012 9.54594 21.9832 9.70669 21.8225C9.86743 21.6617 10.0855 21.5714 10.3128 21.5714C10.5401 21.5714 10.7581 21.6617 10.9189 21.8225C11.0796 21.9832 11.1699 22.2012 11.1699 22.4286Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CartEmpty",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
